import { Stack, Typography, useTheme } from "@mui/material";
import { InfoChip, SelectedCheckCircleIcon } from "components";
import type { AiDetail } from "../../types";
import { PRICING_DESIGN_VALUES } from "./pricingDesignValues";

interface AiDetailCardProps {
  detail: AiDetail;
}

export const AiDetailCard = ({ detail }: AiDetailCardProps) => {
  const theme = useTheme();
  const mutedText = theme.palette.lightBg.low;

  return (
    <Stack
      sx={{
        gap: "16px",
        padding: "12px",
        border: `1px solid ${theme.palette.neutral["010"]}`,
        borderRadius: "8px",
      }}
    >
      <InfoChip
        label={detail.tagLabel}
        tone={detail.tagTone}
        icon={detail.tagHasDot ? "dot" : undefined}
        sx={{ alignSelf: "flex-start" }}
      />
      <Typography
        variant="h6"
        component="h4"
        sx={PRICING_DESIGN_VALUES.titleText}
      >
        {detail.title}
      </Typography>
      {detail.description && (
        <Typography variant="body-small" sx={{ color: mutedText }}>
          {detail.description}
        </Typography>
      )}
      {detail.features && (
        <Stack
          component="ul"
          sx={{ gap: "8px", padding: 0, margin: 0, listStyle: "none" }}
        >
          {detail.features.map((feature) => (
            <Stack
              component="li"
              key={feature}
              direction="row"
              alignItems="flex-start"
              sx={{ gap: "4px" }}
            >
              <SelectedCheckCircleIcon
                aria-hidden="true"
                htmlColor={theme.palette.primary.main}
                sx={{ width: "16px", height: "16px", flex: "0 0 16px" }}
              />
              <Typography variant="body-small" sx={{ color: mutedText }}>
                {feature}
              </Typography>
            </Stack>
          ))}
        </Stack>
      )}
    </Stack>
  );
};
